module.exports = "pegasus_template/assets/theme4/large/1.jpg";